import React, { Component } from 'react';
import moment from 'moment';
import { classNames, trigger } from '@philips-internal/oswald-ui-utils';
import './appointment-suggestion-resume-card.css';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { CollapseArrow } from '@philips-internal/oswald-ui-components';
class AppointmentSuggestionResumeCard extends Component {
    getClassName(suffix, addMain = false) {
        const CLASS_NAME_PREFIX = 'c-appointment-suggestion-resume-card';
        return classNames({
            [CLASS_NAME_PREFIX]: addMain,
            [`${CLASS_NAME_PREFIX}__${suffix}`]: Boolean(suffix),
        });
    }
    formatItemMessage(name, startDate, endDate) {
        const formattedStart = moment(startDate).format('HH:mm');
        const formattedEnd = moment(endDate).format('HH:mm');
        let message = `${MessageService.translate(name)} - ${formattedStart}`;
        message += endDate && formattedEnd ? `-${formattedEnd}h` : 'h';
        return message;
    }
    renderAppointmentEvent(event) {
        const { endDate, name, startDate } = event;
        return (React.createElement("div", { className: this.getClassName('event-item'), key: name }, this.formatItemMessage(name, startDate, endDate)));
    }
    render() {
        const { consultationLocation, direction, events, filterParameter, numberOfSuggestions, onClick, open } = this.props;
        const hasEvents = events?.length > 0;
        return (React.createElement("div", { className: this.getClassName(direction, true), onClick: trigger(onClick) },
            React.createElement("div", { className: this.getClassName('details') },
                React.createElement("div", { className: this.getClassName('title') }, MessageService.translate(consultationLocation)),
                hasEvents && events.map((event) => this.renderAppointmentEvent(event))),
            React.createElement("div", { className: this.getClassName('parameter-info') },
                filterParameter && React.createElement("div", { className: this.getClassName('filter-parameter') }, MessageService.translate(filterParameter)),
                React.createElement("div", { className: this.getClassName('number-suggestions') },
                    `${MessageService.translate(numberOfSuggestions)} ${MessageService.translate('tws.appointment-suggestion.suggestions')}`,
                    React.createElement(CollapseArrow, { className: "arrow-tec-appointment-suggestion-resume-card", collapsed: open })))));
    }
}
export default AppointmentSuggestionResumeCard;
//# sourceMappingURL=appointment-suggestion-resume-card.js.map